<template>
    <div class="toolbar" :class="isMobile ? 'col-3' : 'col-10'" :style="isMobile ? 'top: 0' : ''">
        <div class="inner" style="min-width: 90px">
            <div class="car cart-phone"  v-if="isMobile" :class="{ open: showCart }" >
            <a href="javascript:" class="cart-a" :class="{ active: showCart }" @click="toggleCartSidebar()">
              <el-badge :value="getCartCount">
                <i class="fa fa-shopping-cart fa-lg"></i>
              </el-badge>
            </a>
          </div>
            <div class="tools col-12 pt-10" v-else>
              <div class="col-12 pl-0 pr-0" style="max-height: 38px;display: flex;justify-content: space-around">
                <search-bar />
                <div class="car cart-borad ml-10 mr-10" :class="{ open: showCart }">
                  <a href="javascript:" class="cart-a" :class="{ active: showCart }" @click="toggleCartSidebar()">
                    <el-badge :value="getCartCount">
                      {{ $t('cart.cart')}}
                    </el-badge>
                  </a>
                </div>
                <div class="car cart-borad login">
                  <router-link class="omit" :to="{ name: 'dashboard' }" v-if="user && isLogined">
                    <template v-if="user.nickname">{{ user.nickname }}</template>
                    <template v-else>{{ user.name }}</template>
                  </router-link>
                  <router-link :to="{ name: 'login' }" v-else>
                    {{ $t('app.login')}}
                  </router-link>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import SearchBar from './SearchBar.vue';

  export default {
    name: 'ToolBar',
    data() {
      return {
        shopName: '全部',
        options: ['全部', 'okybuy', 'rakuten', 'yahoo_jp'],
        searchkeyword: '',
      };
    },
    computed: {
      ...mapState({
        user: state => state.user.identity,
        showCart: state => state.cart.showCart,
        searchToolOpened: state => state.app.searchToolOpened,
      }),
      ...mapGetters([
        'isLogined',
        'isMobile',
        'getCartCount',
      ]),
    },
    watch: {
      $route: {
        handler(val) {
          if (val && val.name) {
            if (~val.name.indexOf('rakuten')) {
              this.shopName = 'rakuten';
            } else if (~val.name.indexOf('yahoo_jp')) {
              this.shopName = 'yahoo_jp';
            } else {
              this.shopName = '全部';
            }
            this.searchkeyword = '';
          }
        },
        immediate: true,
      },
    },
    methods: {
      search() {
        const keyword = this.$refs.keyword.value;
        if (keyword) {
          if (this.shopName === 'okubuy' || '全部') {
            this.$router.push({ name: 'search', query: { keyword } });
          }
          if (this.shopName === 'yahoo_jp') {
            this.$router.push({ name: 'yahoo_jp-search', query: { keyword } });
          }
          if (this.shopName === 'rakuten') {
            this.$router.push({ name: 'rakuten-search', query: { keyword } });
          }
        }
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
          if (this.$route.meta.needAuthenticate) {
            this.$router.push({ name: 'home' });
          }
        });
      },
      toggleCartSidebar() {
        this.$store.dispatch('setShowCart', !this.showCart);
      },

    },
    components: {
      SearchBar,
    },
  };
</script>

<style lang="scss">
    @import "../.././styles/helpers/variables";
    @import "../.././styles/helpers/placeholders";
    .login {
      border: 1px solid #F56C6C !important;
      a{
        color: #F56C6C !important;
        text-decoration: none;
      }
    }
    .login:hover {
      box-shadow:  0 2px 5px rgba(0,0,0,.15)!important;
    }
    .omit {
      display: inline-block;
      width: 90%;
      margin: auto;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    // Toolbar
    .toolbar {
        position: absolute;
        top: 10px;
        right: 0;
        min-height: 60px;
        max-height: 120px;
        z-index: 5;
      &.search-visible {
        opacity: 1;
        visibility: visible;
      }
      .el-autocomplete-suggestion {
        display: none;
      }
        .inner {
            display: flex;
            position: relative;
            height: 100%;
            min-height: 100%;
        }

        // Tools
        .tools {
            /*display: table-cell;*/
            /*vertical-align: middle;*/
          display: flex;
          flex-direction: column;
          height: 100%;
          padding-bottom: 8px;
          .top-search{
            width: 100%;
            .el-input-group__prepend{
              .top-search-select{
                width: 80px;
                padding: 0 5px 0 8px;
                .el-input__inner{
                  width: 50px;
                  padding: 0px;
                }
              }
            }
            #top-search-input {
              padding-right: 30px;
              /*&:focus {*/
                /*border-color: #dcdfe6;*/
              /*}*/
            }
            .twitter-typeahead {
              display: block !important;
            }
            .el-input-group__append{
              background-color: initial;
              position: absolute;
              top: 0;
              right: 0;
              width: 5%;
              height: 100%;
              padding: 0;
              display: flex;
              align-items: center;
              border: none;
              .top-search-btn{
                padding: 0;
                margin: auto;
                line-height: 33px;
              }
            }
          }
          input {
            height: 35px;
          }
          .el-input__suffix{
            display: flex;
            right: -5px;
            align-items: center;
          }
        }

      .tt-open, .tt-menu {
        background: $white-color;
        border: 1px solid $gray-light;
        border-top: none;
        color: $gray;
        width: 100%;
      }
      .tt-suggestion {
        padding: 5px 10px;
        font-family: sans-serif;
        font-size: 1rem;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .tt-suggestion:hover, .tt-cursor {
        cursor: pointer;
        color: $white-color;
        background-color: $brand-primary;
      }

        .search, .account, .cart {
            display: inline-block;
            position: relative;
            width: 36px;
            height: 36px;
            margin-left: 6px;
            transition: background-color .35s;
            /*border: 1px solid $border-color;*/
            /*border-radius: 50%;*/
            color: $navbar-tools-color;
            font-size: $tools-icon-size;
            cursor: pointer;
            vertical-align: middle;
            text: {
                align: center;
                decoration: none;
            }
            > i { line-height: $navbar-tools-size - 5; }
            > a {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            &:hover { background-color: $gray-lighter; }
        }
        .account, .cart {
            > a::after {
                display: block;
                position: absolute;
                top: 100%;
                width: 100%;
                height: 18px;
                margin-top: -10px;
                content: '';
            }
        }

        // Search
        .search  > i { line-height: $navbar-tools-size - 4; }

        // Cart
        .cart {
            padding: 0 16px;
            border-radius: floor($navbar-tools-size / 2);
            > a { border-radius: floor($navbar-tools-size / 2); }
            > .count, > .subtotal {
                display: inline-block;
                margin-top: 2px;
                font-size: $font-size-sm;
                vertical-align: middle;
            }
            > .count { margin-left: 5px; }
            > .subtotal {
                margin-left: 11px;
                padding: 1px 0 1px 12px;
                border-left: 1px solid $border-color;
            }
            @media (max-width: $screen-xl) {
                padding: 0 14px;
                &> .subtotal { display: none; }
            }
            .cart-a {
              line-height: 35px;
            }
        }
    }

    // Toolbar Dropdowns
    .toolbar-dropdown {
        @extend %sub-menu;
        margin-top: 7px !important;
        text-align: left;
    }
    .toolbar .account {
        > .toolbar-dropdown {
            left: 50%;
            margin-left: -($sub-menu-width / 2);
        }
    }
    .cart-phone{
      text-align: right;
      position: absolute;
      display: flex;
      align-items: center;
      right: 0;
      width: 45%;
      height: 3rem;
      font-size: 18px;
      padding: 3px;
    }
    .cart-borad{
      width: 12%;
      max-height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      border: 1px solid #0da9ef;
      padding: 3px;
      .el-badge {
        color: #0da9ef;
      }
    }
    .cart-borad:hover {
      box-shadow:  0 2px 5px rgba(0,0,0,.15)!important;
    }
    .toolbar .cart {
        > .toolbar-dropdown {
            right: 0;
            left: auto;
            width: 260px;
            padding: {
                right: 18px !important;
                left: 18px !important;
            }
            > .toolbar-dropdown-group {
                display: table;
                width: 100%;
                padding: {
                    top: 9px;
                    bottom: 9px;
                }
                border-top: 1px solid $border-color;
                &:last-child { border-top: 0; }
                > .column {
                    display: table-cell;
                    vertical-align: top;
                    &:first-child { padding-right: 6px; }
                    &:last-child { padding-left: 6px; }
                }
                .btn { margin: 0; }
            }
        }
    }
    .dropdown-product-item {
        display: table;
        position: relative;
        width: 100%;
        padding: 9px 0;
        border-top: 1px dashed darken($border-color, 3%);
        &:first-child { border-top: 0; }
        > .dropdown-product-thumb,
        > .dropdown-product-info {
            display: table-cell;
            vertical-align: top;
        }
        > .dropdown-product-thumb {
            width: 55px;
            border-radius: 50%;
            overflow: hidden;
            > img {
                display: block;
                width: 100%;
            }
        }
        > .dropdown-product-remove {
            display: block;
            position: absolute;
            top: 12px;
            right: 0;
            color: $brand-danger;
            font-size: $font-size-xs;
            line-height: 1;
            cursor: pointer;
        }
        > .dropdown-product-info {
            padding: {
                right: 15px;
                left: 12px;
            }
        }
        .dropdown-product-title {
            display: block;
            padding-top: 2px;
            transition: color .3s;
            color: $nav-link-color;
            font: {
                size: $nav-link-font-size;
                weight: $nav-link-font-weight;
            }
            text-decoration: none;
            &:hover { color: $nav-link-hover-color; }
        }
        .dropdown-product-details {
            color: $gray;
            font-size: $nav-link-font-size;
        }
    }
    .toolbar .account:hover,
    .toolbar .cart:hover {
        > .toolbar-dropdown {
            display: block;
            animation: submenu-show .3s cubic-bezier(.68, -.55, .265, 1.55);
        }
    }
    @media (max-width:320px) {
      .toolbar{
        right: 25px !important;
        .search{
          width: 40px;
          height: 40px;
          margin-left: 4px;
        }
      }
    }
</style>
